import { TPagination } from "@/types";
import { api } from ".";

type TPaginate = Pick<TPagination, "page" | "limit" | "search">;

const userApi = {
  create: async (body: {}) => {
    return await api.post("users", body);
  },

  update: async (body: {}) => {
    return await api.put("users", body);
  },

  signin: async (body: {}) => {
    return await api.post("users/sign-in", body);
  },

  signout: async () => {
    return await api.post("users/sign-out");
  },

  me: async () => {
    return await api.get("users/me");
  },

  restPassword: async (body: {}) => {
    return api.post("users/reset-password", body);
  },

  getById: async (id: number) => {
    return api.get(`users/${id}`);
  },

  myDownliners: async ({ page, limit, search }: TPaginate) => {
    return api.get(
      `users/my-downliners?page=${page}&limit=${limit}&search=${search}`
    );
  },

  myContactStaffs: async ({ page, limit, search }: TPaginate) => {
    return api.get(
      `users/my-contact-staffs?page=${page}&limit=${limit}&search=${search}`
    );
  },

  myContactStaff: async (id: number) => {
    return api.get(`users/my-contact-staffs/${id}`);
  },

  updateMyContactStaffStatus: async (body: {}) => {
    return api.post(`users/my-contact-staff-status`, body);
  },
};

export default userApi;
